import { css } from '@emotion/react';
import React from 'react';

import Heading from '@/src/shared/components/Heading';

const styles = {
  committeeListHeader: css`
    padding: 0.8rem 0 1.2rem 0;
  `,
};

function CommitteeList({ committees }) {
  if (committees.length === 0) {
    return (
      <p>
        You are not on any committees. Please contact your account manager if you have any
        questions.
      </p>
    );
  }

  return (
    <>
      <Heading type={3} theme="default" size="md" weight="bold" css={styles.committeeListHeader}>
        Committees ({committees.length})
      </Heading>
      {committees.map(committee => {
        return <p key={committee.CommitteeCode}>{committee.CommitteeDescription}</p>;
      })}
    </>
  );
}

export default CommitteeList;
